import fetchOwnAdress from './fetchOwnAdress'
import { REPLAN_LABEL_KEY, hasLabel, labelPatch } from './resolveAdressLabels'

/**
 * Haalt het label 'Opnieuw inplannen' van een huishouden zodra er een bezoek
 * voor is ingepland. Het label is een verzoek (van een klusser die zelf niet
 * mag inplannen) en inplannen is het antwoord; bleef het staan, dan stond het
 * huishouden met een stale vlag in de tabel en zou de planner het zelf moeten
 * opruimen.
 *
 * Leest het huishouden via `fetchOwnAdress` (eigen organisatie, `ID`-veld,
 * niet verwijderd) en schrijft alleen als het label er echt staat — de andere
 * labels blijven.
 * AI-CONTEXT: See docs/features/planner-overzicht-bkb.md
 *
 * @param {{AdressID?: string}} task - De bevestigde afspraak
 * @returns {Promise<boolean>} Of het label weggehaald is
 */
const clearReplanLabel = async (task) => {
    const doc = await fetchOwnAdress(task?.AdressID)
    if (!doc) return false

    const adress = doc.data()
    if (!hasLabel(adress, REPLAN_LABEL_KEY)) return false

    await doc.ref.update(labelPatch(adress, REPLAN_LABEL_KEY, false))
    return true
}

export default clearReplanLabel
